import { useCallback, useContext } from 'react'
import { ProductsTableContext } from '../context'
import { useSelection } from '@shared/modules/next-table/hooks/use-selection'
import { message, Modal } from 'antd'
import { ProductsService } from '../services'
import { useBackgroundNavigate } from '@shared/hooks'

export const useProductsTableActions = () => {
  const navigate = useBackgroundNavigate()

  const { state, handleFetch, handleReset, handleSelectAll, handleResetSelection } = useContext(ProductsTableContext)
  const selection = useSelection(state.selectedRowIds)

  const handleRemove = useCallback(() => {
    const action = async () => {
      const result = await ProductsService.actionByIds(selection, 'remove')

      if (result.status === 200) {
        message.success('Əməliyyat müvəffəqiyyətlə başa çatdı.')
        await handleFetch()
      } else {
        message.error(result.data)
      }
    }

    Modal.confirm({
      title: 'Silməyə əminsinizmi?',
      content: 'Silmə əməliyyatını təsdiqlədikdən sonra məlumatların geri qaytarılması mümkün olmayacaq.',
      onOk: action,
    })
  }, [handleFetch, selection])

  const goToCreate = useCallback(() => {
    navigate('/products/create', { withBackground: true })
  }, [navigate])

  return { selection, handleFetch, handleResetSelection, handleSelectAll, handleReset, handleRemove, goToCreate }
}
